import { createElement, Fragment } from 'react';
import { string, oneOf, oneOfType, number } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import classNames from 'classnames';
import 'reakit/Avatar';
import _Avatar, { AvatarCircle } from './styled.js';

var Avatar = function Avatar(_ref) {
  var _classNames, _classNames2;

  var a11yLabel = _ref.a11yLabel,
      className = _ref.className,
      initials = _ref.initials,
      size = _ref.size,
      src = _ref.src,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yLabel", "className", "initials", "size", "src"]);

  return createElement(Fragment, null, src && createElement(_Avatar, _extends({
    alt: a11yLabel,
    className: classNames((_classNames = {}, _classNames[className || ''] = Boolean(className), _classNames)),
    styledSize: size,
    src: src
  }, props)), initials && createElement(AvatarCircle, _extends({
    className: classNames((_classNames2 = {}, _classNames2[className || ''] = Boolean(className), _classNames2)),
    styledSize: size
  }, props), initials.split(' ').length === 2 ? initials.match(/\b\w/g) : initials.substring(0, 2)));
};
var avatarPropTypes = {
  a11yLabel: string,
  alt: string,
  kind: oneOf(['circle', 'square']),
  color: string,
  className: string,
  fit: oneOf(['cover', 'contain']),
  fitPosition: string,
  initials: string,
  palette: string,
  size: oneOfType([number, oneOf(['default', 'xsmall', 'small', 'medium', 'large'])]),
  src: string
};
Avatar.propTypes = avatarPropTypes;
var avatarDefaultProps = {
  a11yLabel: undefined,
  alt: undefined,
  kind: 'square',
  className: undefined,
  color: undefined,
  fit: undefined,
  fitPosition: undefined,
  initials: undefined,
  palette: undefined,
  size: 'default',
  src: undefined
};
Avatar.defaultProps = avatarDefaultProps;
var C = Avatar;

export default C;
export { C as Avatar, avatarDefaultProps, avatarPropTypes };
